export default __webpack_public_path__ + "static/media/ris_logo_ball.cd5e2def.svg";